export const HEADER_HEIGHT = 71;
export const PORTAL_HEADER_HEIGHT = 60;
export const PAGE_HEADER_HEIGHT = 114;
export const APPLY_EVALUATION_RULES_HEADER_CONTROLS = 48;
export const MAIN_SIDEBAR_MENU_WIDTH = 64;
export const MAIN_SIDEBAR_MENU_EXPANDED_WIDTH = 313;
export const CREATE_REQUEST_FOOTER = 80;
export const ACTION_BAR_HEIGHT = 68;
export const SIDEBAR_SECTIONS_WITH_PROGRESS_BAR_WIDTH = 340;
